module.exports = __webpack_public_path__ + "static/media/startup.b7e9306e.png";